exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/academic-integrity.js-WebpackMultiOutput";